import React, { useEffect, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { Button, Divider, List } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Filter from "../common/filter/filter";

const messages = defineMessages({
    settingsPageBreadcrumbs: {
        id: "manage-labourers-filter.breadcrumbs",
        defaultMessage: "Back",
        description: "Settings breadcrumbs caption",
    },
    contractNameFilterTitle: {
        id: "manage-labourers-filter.contractName",
        defaultMessage: "Contract Name",
        description: "Title for filtering on contract names",
    },
    skillsFilterTitle: {
        id: "manage-labourers-filter.skills",
        defaultMessage: "Skills",
        description: "Title for filtering on skills",
    },
});
const useStyles = makeStyles({
    root: {
        textTransform: "none",
        fontFamily: "Arial",
        disableRipple: true,
        padding: "5px",
        lineHeight: 5,
    },
    listText: {
        fontSize: "12px",
        textTransform: "none",
        fontWeight: 400,
        fontFamily: "Arial",
        disableRipple: true,
    },
    listPrimary: {
        fontSize: "14px",
        fontWeight: 700,
        fontFamily: "Arial",
        color: "#555555",
    },
    listSecondary: {
        fontSize: "12px",
        fontWeight: 700,
        fontFamily: "Arial",
        color: "#555555",
    },
    cmisBreadcrumb: {
        color: "#00549A ",
    },
    spacing: {
        paddingTop: 0,
        paddingBottom: 0,
    },
});

function ManageLabourerSidebar(props) {
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const [selectedFilters, setFilter] = useState({
        contractNumber: { items: [], all: true },
        skillId: { items: [], all: true },
    });

    useEffect(() => {
        props.handleFilteredTechnicians(
            props.technicians.filter((tech) => {
                const techContractNums = tech.contracts.map((contract) => contract.contractNumber);
                const isInFilteredContract = selectedFilters.contractNumber.all
                    ? true
                    : techContractNums.some((contractNum) => selectedFilters.contractNumber.items.includes(contractNum));

                const techSkillIds = tech.skills.map((skill) => skill.id);
                const isInFilteredSkills = selectedFilters.skillId.all ? true : techSkillIds.some((id) => selectedFilters.skillId.items.includes(id));

                return isInFilteredContract && isInFilteredSkills;
            }),
        );
    }, [selectedFilters]);

    return (
        <>
            <List>
                <Button className={classes.cmisBreadcrumb} onClick={() => history.goBack()}>
                    {"< " + intl.formatMessage(messages.settingsPageBreadcrumbs)}
                </Button>
            </List>
            <Divider variant="middle" />
            <Filter
                title={intl.formatMessage(messages.contractNameFilterTitle)}
                filterOptions={props.contracts}
                filterKeys={{
                    value: "contractNumber",
                    name: "description",
                }}
                inputFilter={selectedFilters.contractNumber}
                onUpdateFilter={(filter) => setFilter({ ...selectedFilters, contractNumber: filter })}
                useAll
            />
            <Divider variant="middle" />
            <Filter
                title={intl.formatMessage(messages.skillsFilterTitle)}
                filterOptions={props.skills}
                filterKeys={{
                    value: "id",
                    name: "name",
                }}
                inputFilter={selectedFilters.skillId}
                onUpdateFilter={(filter) => setFilter({ ...selectedFilters, skillId: filter })}
                useAll
                useFiltersTitle={false}
            />
        </>
    );
}

export default ManageLabourerSidebar;
